import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Chart, registerables} from 'chart.js';
import Utils from './utils/utils';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-chart-view',
  imports: [
    NgIf
  ],
  templateUrl: './chart-view.component.html',
  styleUrl: './chart-view.component.scss'
})
export class ChartViewComponent {

  @ViewChild('elementChartCanvas', {static: true}) elementChartCanvas?: ElementRef;

  @Input() chartData: any = '';

  ngOnInit() {
    const sandbox = new Function('Utils', `
        let chartResult = {};
        ${this.chartData.chart_data} ${this.chartData.chart_config};
        chartResult.data = data;
        chartResult.config = config;
        return chartResult;
    `);
    const {data, config} = sandbox(Utils);
    Chart.register(...registerables);
    new Chart(this.elementChartCanvas?.nativeElement as any, config as any);
  }
}
